var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef } from 'react';
import { useAuth } from '@/lib/AuthContext';
import { fetchClients, createClient as createClientApi, updateClient as updateClientApi, deleteClient as deleteClientApi, updateNotificationSettings as updateNotificationSettingsApi, } from '@/lib/api';
import { fetchSubscription, canCreateClient } from '@/lib/subscription';
import { ErrorBoundary } from '@/components/errorBoundary/ErrorBoundary';
import { Sidebar } from '@/components/sidebar/Sidebar';
import { TopBar } from '@/components/topBar/TopBar';
import { AddClientModal } from '@/components/modal/AddClientModal';
import { UpgradeModal } from '@/components/modal/UpgradeModal';
import { AuthPage } from '@/pages/auth/AuthPage';
import { LandingPage } from '@/pages/landing/LandingPage';
import { Dashboard } from '@/pages/dashboard/Dashboard';
import { CalendarPage } from '@/pages/calendar/CalendarPage';
import { SettingsPage } from '@/pages/settings/SettingsPage';
import { ClientDetail } from '@/pages/clientDetail/ClientDetail';
import { PortalPreview } from '@/pages/portalPreview/PortalPreview';
import * as styles from './App.module.scss';
var AppContent = function () {
    var _a;
    var _b = useAuth(), user = _b.user, signOut = _b.signOut;
    var _c = useState([]), clients = _c[0], setClients = _c[1];
    var _d = useState(null), selectedClient = _d[0], setSelectedClient = _d[1];
    var _e = useState('dashboard'), view = _e[0], setView = _e[1];
    var _f = useState('closed'), modalMode = _f[0], setModalMode = _f[1];
    var _g = useState(true), loading = _g[0], setLoading = _g[1];
    var _h = useState(null), subscription = _h[0], setSubscription = _h[1];
    var _j = useState(false), sidebarOpen = _j[0], setSidebarOpen = _j[1];
    // ─── Global timer state (survives all navigation) ─────────────
    var _k = useState(false), timerRunning = _k[0], setTimerRunning = _k[1];
    var _l = useState(0), timerSeconds = _l[0], setTimerSeconds = _l[1];
    var _m = useState(null), timerProjectId = _m[0], setTimerProjectId = _m[1];
    var _o = useState(''), timerDesc = _o[0], setTimerDesc = _o[1];
    var timerIntervalRef = useRef(null);
    useEffect(function () {
        if (timerRunning) {
            timerIntervalRef.current = setInterval(function () {
                setTimerSeconds(function (s) { return s + 1; });
            }, 1000);
        }
        return function () {
            if (timerIntervalRef.current)
                clearInterval(timerIntervalRef.current);
        };
    }, [timerRunning]);
    var timerState = {
        timerRunning: timerRunning,
        timerSeconds: timerSeconds,
        timerProjectId: timerProjectId,
        timerDesc: timerDesc,
        onTimerStart: function () { return setTimerRunning(true); },
        onTimerStop: function () {
            setTimerRunning(false);
            if (timerIntervalRef.current)
                clearInterval(timerIntervalRef.current);
        },
        onTimerReset: function () { setTimerSeconds(0); setTimerDesc(''); },
        onTimerProjectChange: setTimerProjectId,
        onTimerDescChange: setTimerDesc,
    };
    useEffect(function () {
        loadClients();
        loadSubscription();
    }, []);
    useEffect(function () {
        var params = new URLSearchParams(window.location.search);
        if (params.get('checkout') === 'success') {
            window.history.replaceState({}, '', window.location.pathname);
            setTimeout(function () { return loadSubscription(); }, 1500);
        }
    }, []);
    var loadClients = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, updated, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    setLoading(true);
                    return [4 /*yield*/, fetchClients()];
                case 1:
                    data = _a.sent();
                    setClients(data);
                    // Обновляем selectedClient если он есть
                    if (selectedClient) {
                        updated = data.find(function (c) { return c.id === selectedClient.id; });
                        if (updated)
                            setSelectedClient(updated);
                    }
                    return [3 /*break*/, 4];
                case 2:
                    err_1 = _a.sent();
                    console.error('Failed to load clients:', err_1);
                    return [3 /*break*/, 4];
                case 3:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    // Лёгкая перезагрузка без спиннера — для обновлений внутри ClientDetail
    var refreshClients = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, updated, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, fetchClients()];
                case 1:
                    data = _a.sent();
                    setClients(data);
                    if (selectedClient) {
                        updated = data.find(function (c) { return c.id === selectedClient.id; });
                        if (updated)
                            setSelectedClient(updated);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    err_2 = _a.sent();
                    console.error('Failed to refresh clients:', err_2);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var loadSubscription = function () { return __awaiter(void 0, void 0, void 0, function () {
        var sub, err_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, fetchSubscription()];
                case 1:
                    sub = _a.sent();
                    setSubscription(sub);
                    return [3 /*break*/, 3];
                case 2:
                    err_3 = _a.sent();
                    console.error('Failed to load subscription:', err_3);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleSelectClient = function (client) {
        setSelectedClient(client);
        setView('client');
    };
    var handleDashboard = function () {
        setSelectedClient(null);
        setView('dashboard');
    };
    var handleCalendar = function () {
        setSelectedClient(null);
        setView('calendar');
    };
    var handleSettings = function () {
        setSelectedClient(null);
        setView('settings');
    };
    var handleOpenAddClient = function () { return __awaiter(void 0, void 0, void 0, function () {
        var allowed;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, canCreateClient()];
                case 1:
                    allowed = _a.sent();
                    if (allowed) {
                        setModalMode('add');
                    }
                    else {
                        setModalMode('upgrade');
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleAddClient = function (newClient_1) {
        var args_1 = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args_1[_i - 1] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([newClient_1], args_1, true), void 0, function (newClient, enableNotifications) {
            var created_1, _a, err_4;
            if (enableNotifications === void 0) { enableNotifications = true; }
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 6, , 7]);
                        return [4 /*yield*/, createClientApi({
                                name: newClient.name,
                                company: newClient.company,
                                email: newClient.email,
                                avatar: newClient.avatar,
                                color: newClient.color,
                            })];
                    case 1:
                        created_1 = _b.sent();
                        setClients(function (prev) { return __spreadArray([created_1], prev, true); });
                        if (!!enableNotifications) return [3 /*break*/, 5];
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, updateNotificationSettingsApi(created_1.id, {
                                notify_project_created: false,
                                notify_project_status: false,
                                notify_invoice_created: false,
                            })];
                    case 3:
                        _b.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        _a = _b.sent();
                        return [3 /*break*/, 5];
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        err_4 = _b.sent();
                        console.error('Failed to create client:', err_4);
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    var handleUpdateClient = function (clientId, data) { return __awaiter(void 0, void 0, void 0, function () {
        var mapped_1, err_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, updateClientApi(clientId, data)];
                case 1:
                    _a.sent();
                    mapped_1 = {
                        name: data.name,
                        company: data.company,
                        email: data.email,
                        color: data.color,
                        avatar: data.avatar,
                        showCardInPortal: data.show_card_in_portal,
                    };
                    setClients(function (prev) {
                        return prev.map(function (c) {
                            return c.id === clientId ? __assign(__assign({}, c), mapped_1) : c;
                        });
                    });
                    if ((selectedClient === null || selectedClient === void 0 ? void 0 : selectedClient.id) === clientId) {
                        setSelectedClient(function (prev) { return (prev ? __assign(__assign({}, prev), mapped_1) : prev); });
                    }
                    return [3 /*break*/, 3];
                case 2:
                    err_5 = _a.sent();
                    console.error('Failed to update client:', err_5);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleDeleteClient = function (clientId) { return __awaiter(void 0, void 0, void 0, function () {
        var err_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, deleteClientApi(clientId)];
                case 1:
                    _a.sent();
                    setClients(function (prev) { return prev.filter(function (c) { return c.id !== clientId; }); });
                    if ((selectedClient === null || selectedClient === void 0 ? void 0 : selectedClient.id) === clientId) {
                        setSelectedClient(null);
                        setView('dashboard');
                    }
                    return [3 /*break*/, 3];
                case 2:
                    err_6 = _a.sent();
                    console.error('Failed to delete client:', err_6);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handlePortalPreview = function () {
        if (selectedClient) {
            setView('portal');
        }
    };
    var currentPlan = (subscription === null || subscription === void 0 ? void 0 : subscription.plan) || 'free';
    return (_jsxs("div", { className: styles.app, children: [_jsx(Sidebar, { clients: clients, selectedClientId: (_a = selectedClient === null || selectedClient === void 0 ? void 0 : selectedClient.id) !== null && _a !== void 0 ? _a : null, onSelectClient: handleSelectClient, onDashboard: handleDashboard, onCalendar: handleCalendar, onSettings: handleSettings, onAddClient: handleOpenAddClient, onPortalPreview: handlePortalPreview, plan: currentPlan, isOpen: sidebarOpen, onClose: function () { return setSidebarOpen(false); }, activeView: view }), _jsxs("main", { className: styles.main, children: [_jsx(TopBar, { clientName: selectedClient === null || selectedClient === void 0 ? void 0 : selectedClient.name, onBreadcrumbClick: handleDashboard, onSignOut: signOut, userEmail: user === null || user === void 0 ? void 0 : user.email, plan: currentPlan, onUpgrade: function () { return setModalMode('upgrade'); }, onMenuToggle: function () { return setSidebarOpen(true); } }), _jsx("div", { className: styles.content, children: loading ? (_jsxs("div", { className: styles.loadingState, children: [_jsx("div", { className: styles.spinner }), _jsx("div", { children: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u0434\u0430\u043D\u043D\u044B\u0445..." })] })) : view === 'dashboard' ? (_jsx(Dashboard, { clients: clients, onSelectClient: handleSelectClient })) : view === 'calendar' ? (_jsx(CalendarPage, { clients: clients, onSelectClient: handleSelectClient })) : view === 'client' && selectedClient ? (_jsx(ClientDetail, { client: selectedClient, onEditClient: function () { return setModalMode('edit'); }, isPro: currentPlan === 'pro', onUpgrade: function () { return setModalMode('upgrade'); }, onDataChanged: refreshClients, timerState: timerState })) : view === 'settings' ? (_jsx(SettingsPage, { userEmail: user === null || user === void 0 ? void 0 : user.email, plan: currentPlan, onUpgrade: function () { return setModalMode('upgrade'); } })) : view === 'portal' && selectedClient ? (_jsx(PortalPreview, { client: selectedClient, onClose: function () { return setView('client'); } })) : null })] }), (modalMode === 'add' || modalMode === 'edit') && (_jsx(AddClientModal, { client: modalMode === 'edit' ? selectedClient : null, onClose: function () { return setModalMode('closed'); }, onAdd: handleAddClient, onUpdate: handleUpdateClient, onDelete: handleDeleteClient, isPro: currentPlan === 'pro', onUpgrade: function () {
                    setModalMode('upgrade');
                } })), modalMode === 'upgrade' && (_jsx(UpgradeModal, { onClose: function () { return setModalMode('closed'); } }))] }));
};
export var App = function () {
    var _a = useAuth(), session = _a.session, loading = _a.loading;
    var _b = useState(false), showAuth = _b[0], setShowAuth = _b[1];
    if (loading) {
        return (_jsxs("div", { className: styles.loadingPage, children: [_jsx("div", { className: styles.logoMark, children: "CB" }), _jsx("div", { children: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430..." })] }));
    }
    if (!session) {
        if (showAuth) {
            return _jsx(AuthPage, { onBack: function () { return setShowAuth(false); } });
        }
        return (_jsx(LandingPage, { onGetStarted: function () { return setShowAuth(true); }, onLogin: function () { return setShowAuth(true); } }));
    }
    return (_jsx(ErrorBoundary, { children: _jsx(AppContent, {}) }));
};
